import { v4 as uuid } from "uuid";
import DossierAPI from "@/api/DossierAPI";
import WPAPI from "@/api/WPAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {DOSSIER} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import DB from "@/models/DB";
import {Dossier} from "@/models/Dossier";
import { WorkprocessModel } from "@/models/PPC/Workprocess";


let initDossierData = localStorage.getItem("initDossier");
if(initDossierData) {
    initDossierData = JSON.parse(initDossierData);
    initDossierData.dossier = DB.newModel(initDossierData.dossier, Dossier);
    initDossierData.mainWorkProcess = DB.newModel(initDossierData.mainWorkProcess, WorkprocessModel);
    initDossierData.workprocesses = DB.newCollection(initDossierData.workprocesses, WorkprocessModel);
    //let newDossier = localStorage.setItem("initDossier", JSON.stringify( {dossier: state.initdossier.dossier, mainWorkProcess: state.initdossier.mainWorkProcess, workprocesses: state.initdossier.workprocesses.items } ) );
}

export const initialState = {
    selected: false,
    selectedDossiers: {},
    selectedTask: "sr741ZN9YJ-98368310928345                         ",
    selectedPanel: 1,
    newDossier: null,
    dossiers: null,
    quicksearch: [],
    workprocesses: [],
    wp_sectors: [],
    wp_departments: [],
    customers: [],
    sectors: [],
    users: [],
    searchResult: [],
    view: DOSSIER.VIEW_OVERVIEW,
    apiState: DOSSIER.API_INIT,
    key: "",
    error: null,
    searchOn: null,
    initdossier: initDossierData,
};


let newDossier = localStorage.getItem("newDossier");
if(newDossier) {
    if(window.location.pathname == '/dossiers/new') {
    newDossier = JSON.parse(newDossier);
    initialState.selected = DB.newModel(newDossier, Dossier);
    initialState.selected.createModel(newDossier, {children: Dossier});
    initialState.apiState = DOSSIER.API_READY;
    initialState.view = DOSSIER.VIEW_NEW;
    } else {
        localStorage.removeItem("newDossier");
    }
}



const setInitState = () => {
    return initialState;
}

const rejectEventHandlerSchedule=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);

});
const pendingEventHandlerSchedule=((state, action) => {
    state.apiState = DOSSIER.API_PROCESSING;
    
})
let fullFilledEventHandlerSchedule= ( (state, action) => {
    if(action.payload.data.initdossier) {
        const mainWorkProcess = DB.newModel(action.payload.data.initdossier, WorkprocessModel);
        const initDossier = DB.newModel( {name: mainWorkProcess.name}, Dossier);
        state.initdossier = {dossier: initDossier, mainWorkProcess:mainWorkProcess};
    }
    
    if(action.payload.data.wp) {
        state.initdossier.workprocesses = DB.newCollection(action.payload.data.wp, WorkprocessModel);
    }
  if(action.payload.data.dossiers) {
      state.dossiers = DB.newCollection(action.payload.data.dossiers, Dossier);
      
  }
  if(action.payload.data.sectors) {
      state.sectors = action.payload.data.sectors; 
  }
    if(action.payload.data.customers) {
        state.customers = action.payload.data.customers;    
    }
    if(action.payload.data.dossier) {
        state.selected = new Dossier(action.payload.data.dossier);
    }
    
    switch(action.type) {
        case 'CREATE_DOSSIER/fulfilled' :
//            state.view = DOSSIER.VIEW_NEW;
//            localStorage.setItem("newDossier", JSON.stringify(state.selected.getData()) );
            
            break;
        default:
            state.view = DOSSIER.VIEW_OVERVIEW;
            state.selected = null;
            
    }
    
  state.apiState = DOSSIER.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;

    return state;
})  


const DossierReducer = createSlice({
  name: 'Dossier',
  initialState: setInitState(),
  reducers: {
      setTaskKey:  ((state = null, action = null) => {
          state.selectedTask = action.payload.key;
          state.key = uuid().slice(0, 8);
          }),
          nextStepInitDossier:  ((state = null, action = null) => {
            
            
            if(action.payload.step && state.initdossier) {
                let newDossier = localStorage.setItem("initDossier", JSON.stringify( {dossier: state.initdossier.dossier, mainWorkProcess: state.initdossier.mainWorkProcess, workprocesses: state.initdossier.workprocesses.items } ) );
            }
            }),
      showOverview:  ((state = null, action = null) => {
          state.selectedPanel = 1;
          state.selectedTask = null;
        state.view = DOSSIER.VIEW_OVERVIEW;
        state.apiState = DOSSIER.API_READY;
        state.selected = null;
      state.key = uuid().slice(0, 8);
          
      })
    // omit existing reducers here
  },
  extraReducers(builder) {
    let task = null;
/*    
    builder.addCase(dossierStore.fulfilled, (state, action) => {
      state.key = uuid().slice(0, 8);
      state.error = null;
      state.apiState = DOSSIER.API_READY;
    }).addCase(dossierStore.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(dossierStore.pending, (state, action) => {
        state.apiState = DOSSIER.API_PROCESSING;
    });
*/

   task = getDossiers;
   builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

   task = initDossier;
   builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));
      
   task = createDossier;
   builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandlerSchedule(state, action)).addCase(task.rejected, (state, action) => rejectEventHandlerSchedule(state, action)).addCase(task.pending, (state, action) => pendingEventHandlerSchedule(state, action));

       builder.addCase(storeWorklog.fulfilled, (state, action) => {
        if(action.payload.data.selectedTask) {
            if(action.payload.data.worklog) {
                //let selected = current(state.selected)
                
            let selectedItem = state.selected.getTaskByKey(action.payload.data.selectedTask, 'key');
            selectedItem.worklog = DB.newModel(action.payload.data.worklog);
            state.selectedTask = selectedItem.ref;
            state.selectedPanel = 2;
//            
                
                
                //selected = {...selected, worklog: action.payload.data.worklog}
                //let scheduleItem = DB.newModel(selected);
                //state.selected = selected;
            }
        }
        state.view = DOSSIER.VIEW_VIEW;
        state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
        
        });

    builder.addCase(closeTask.fulfilled, (state, action) => {
        console.debug("found selected item", action.payload.data  )
        if(action.payload.data.dossierKey) {
            console.debug("has dossier key", action.payload.data  )
            }
        if(action.payload.data.oldState) {
            console.debug("has dossier key oldState", action.payload.data.oldState  )
            }
        if(action.payload.data.newState) {
            console.debug("has dossier key newdState", action.payload.data.newState  )
            }
            
        if(action.payload.data.dossierKey && action.payload.data.newState) {
        console.debug("found selected item", action.payload.data  )
            let selectedItem = state.selected.getTaskByKey(action.payload.data.dossierKey, 'key');
            console.debug("found selected item", selectedItem  )
            if(selectedItem && selectedItem.state != action.payload.data.newState) {
                selectedItem.state = action.payload.data.newState;

                //state.view = DOSSIER.VIEW_VIEW;
                state.apiState = DOSSIER.API_READY;
                state.key = uuid().slice(0, 8);
                state.error = null;
                
            }
        }
    
    }).addCase(closeTask.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(closeTask.pending, (state, action) => {
//        state.apiState = DOSSIER.API_PROCESSING;
    });

    builder.addCase(viewDossier.fulfilled, (state, action) => {
        if(action.payload.data.customers) {
            state.customers = action.payload.data.customers;    
        }
        if(action.payload.data?.dossier) {
            
            state.selected = new Dossier(action.payload.data?.dossier);
            
        }
        if(action.payload.data.users) {
            state.users = action.payload.data.users;
        }
        state.view = DOSSIER.VIEW_VIEW;
        state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(viewDossier.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(viewDossier.pending, (state, action) => {
        state.apiState = DOSSIER.API_PROCESSING;
    });


    builder.addCase(getDossier.fulfilled, (state, action) => {
        if(action.payload.data.customers) {
            state.customers = action.payload.data.customers;    
        }
            
            
        if(action.payload.data.dossier) {
            
            state.selected = new Dossier(action.payload.data.dossier);
            ;
        }
        if(action.payload.data.users) {
            state.users = action.payload.data.users;
        }
        state.view = DOSSIER.VIEW_EDIT;
        state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(getDossier.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(getDossier.pending, (state, action) => {
        state.apiState = DOSSIER.API_PROCESSING;
    });

    builder.addCase(searchWorkprocesses.fulfilled, (state, action) => {
        if(action.payload.data.items) {
            state.workprocesses = DB.newCollection(action.payload.data.items);
        }
    if(action.payload.data.sectors) {
        state.wp_sectors = DB.newCollection(action.payload.data.sectors);
    }
    if(action.payload.data.departments) {
        state.wp_departments = DB.newCollection(action.payload.data.departments);
    }
        
        state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(searchWorkprocesses.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(searchWorkprocesses.pending, (state, action) => {
        state.apiState = DOSSIER.API_PROCESSING;
    });


    builder.addCase(saveDossier.fulfilled, (state, action) => {
        if(action.payload.data.dossiers) {
            state.dossiers = DB.newCollection(action.payload.data.dossiers, Dossier);
        }
        if(action.payload.data.sectors) {
            state.sectors = action.payload.data.sectors;
        }
        state.selected = null;        
        state.view = DOSSIER.VIEW_OVERVIEW;
      state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(saveDossier.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(saveDossier.pending, (state, action) => {
        state.view = DOSSIER.VIEW_NEW;
        state.apiState = DOSSIER.API_PROCESSING;
    });
    
        builder.addCase(quickSearch.fulfilled, (state, action) => {
            
        if(action.payload.data.searchResult) {
            state.searchResult = DB.newCollection(action.payload.data.searchResult);
        }

    });



    task = searchDossier
    builder.addCase(task.fulfilled, (state, action) => {
        if(action.payload.data.dossiers) {
            state.searchResult = action.payload.data.searchResult;
        }
      state.apiState = DOSSIER.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(task.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(task.pending, (state, action) => {
        state.apiState = DOSSIER.API_PROCESSING;
    }); 


    builder.addMatcher(
      (action) => action.type == ('USER_CHECKAUTH/fulfilled'),
      (state, action) => {
        if(action.payload.data.data.customers) {
            state.customers = action.payload.data.data.customers;
        }
        
       });

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {

        state.selected = false;
        state.newDosier = null;
        state.dossiers = [];
        state.workprocesses = [];
        state.customers = [];
        state.sectors = [];
        state.users = [];
        state.searchResult = [];
        state.view = DOSSIER.VIEW_OVERVIEW;
        state.apiState = DOSSIER.API_INIT
        state.key = "";
          state.error = null;
       })

    
  }
  })

export const quickSearch = createAsyncThunk(DOSSIER.QUICK_SEARCH, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.quickSearch(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const saveDossier = createAsyncThunk(DOSSIER.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          
          response = await DossierAPI.store(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const initDossier = createAsyncThunk(DOSSIER.INIT_DOSSIER, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.initDossier(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const createDossier = createAsyncThunk(DOSSIER.CREATE_DOSSIER, async (data, event) => {
    let response = null;
    try {
        let postDataObj = {};
        if(data.workprocesses) {
            postDataObj.workprocesses = data.workprocesses.getData();
        }
        if(data.dossier) {
            postDataObj.dossier = data.dossier.getData();
        }
        if(data.mainWorkProcess) {
            postDataObj.mainWorkProcess = data.mainWorkProcess.getData();
        }
        
          //response = await DossierAPI.store(data);
          response = await DossierAPI.createDossier(postDataObj);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const searchWorkprocesses = createAsyncThunk(DOSSIER.SEARCH_WP, async (data = null, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await WPAPI.getWorkprocesses(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const getDossiers = createAsyncThunk(DOSSIER.GET_DOSSIERS, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.index();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const viewDossier = createAsyncThunk(DOSSIER.VIEW_DOSSIER, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.get(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const getDossier = createAsyncThunk(DOSSIER.GET_DOSSIER, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          
          response = await DossierAPI.get(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const searchDossier = createAsyncThunk(DOSSIER.SEARCH_DOSSIERS, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.searchDossiers(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const searchDossierOn = createAsyncThunk("SearchDossierOn", async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.searchDossiersOn(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const storeWorklog = createAsyncThunk(DOSSIER.STORE_WORKLOG, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.storeWorklog(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const closeTask = createAsyncThunk(DOSSIER.CLOSE_TASK, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.closeTask(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getAllDescriptions = createAsyncThunk(DOSSIER.GET_ALL_DESCRIPTIONS, async (data:any, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.getAllDescriptions(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

 
/*
export const dossierStore = createAsyncThunk(DOSSIER.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          //response = await DossierAPI.store(data);
          response = await DossierAPI.index();
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)
*/

export const { showOverview, setTaskKey, nextStepInitDossier } = DossierReducer.actions;
export default DossierReducer.reducer